/** @jsxImportSource @emotion/react */

import { DocType, DocumentView } from './DocumentView'

const MarketingConsents = () => {
    return <DocumentView type={DocType.marketingConsents} />
}

export { MarketingConsents }
